module.exports = require("npm:fizzy-ui-utils@2.0.4/utils.js");